<template>
  <div class="col-lg-12">
    <div class="row">
      <div class="col-11">
        <button class="btn waves-effect waves-light btn-success" data-toggle="modal" data-target="#seedModal" data-whatever="@getbootstrap">
          <i class="fas fa-plus" />&nbsp; Seed
        </button>
      </div>
      <div class="col-1 text-right p-l-0">
        <div class="form-group">
          <select id="year" v-model="year" class="form-control" name="year" @change="yearChangeHandler">
            <option v-for="(year,index) in yearList" :key="index" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="inputList.seed && inputList.seed.length>0" class="table-responsive">
      <table class="table no-wrap v-middle">
        <thead>
          <tr class="border-0">
            <th class="border-0">
              Seed
            </th>
            <th class="border-0">
              Variety
            </th>
            <th class="border-0">
              Amount
            </th>
            <th class="border-0">
              Purchase Price
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(seed, index) in inputList.seed" :key="index">
            <td>{{ seed.crop }}</td>
            <td>{{ seed.type }}</td>
            <td>{{ seed.amount }} {{ seed.amount_units }}</td>
            <td>{{ seed.price_amount }} {{ seed.price_units }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="card-header p-l-0">
      <h4 class="card-title text-muted">
        No seeds are added for this farm for the selected year.
      </h4>
    </div>
    <seed-modal :prop-year="year" />
  </div>
</template>

<script>

import SeedModal from './modals/SeedModal'

export default {
  name: 'Seed',
  components: { SeedModal },
  data () {
    return {
      inputList: {},
      yearList: [],
      year: (new Date()).getFullYear()
    }
  },
  mounted () {
    this.getInputList()
  },
  methods: {
    async getInputList () {
      const reply = await this.$api.get('/growers/inputs', {
        params: {
          year: this.year
        }
      })
      this.inputList = reply.data
      const currentYear = (new Date()).getFullYear()
      this.yearList = []
      for (var i = 0; i < 5; i++) {
        this.yearList.push(parseInt(currentYear) + i)
      }
    },
    handleSubmit () {
    },
    async save () {
    },
    reset () {
    },
    yearChangeHandler () {
      this.getInputList()
    }
  }
}
</script>

<style scoped>
</style>
